import styled from 'styled-components';

interface InputProps {
  active?: boolean;
}

export const Input = styled.input<InputProps>`
  font-size: 12px;
  font-weight: 600;
  height: 35px;
  padding: 8px 10px;
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.table.header};
  color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.text};
  align-self: flex-start;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.inputBorder};
  outline: none;
  width: ${(props) => `${props.value}`.length}ch;
  min-width: 80px;

  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors.text};
    border: 1px solid ${(props) => props.theme.colors.primary};
  }
`;
